import { Link } from '@rocketlane/rocket-router';
import styled, { createGlobalStyle } from 'styled-components';
export const SIDEBAR_EXPANDED_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 52;
export const SidebarRoot = styled.aside`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${({ $collapsed })=>$collapsed ? `${SIDEBAR_COLLAPSED_WIDTH}px` : `${SIDEBAR_EXPANDED_WIDTH}px`};
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: var(--scarlet-gray-10, #fafafa);
  border-right: 1px solid var(--scarlet-gray-60, #ededed);
  padding: 8px;
  transition: width 0.2s ease;
`;
export const SidebarScroll = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: ${({ $collapsed })=>$collapsed ? '8px' : '0'};
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--black-20, #c6c6c6);
    border-radius: 2px;
  }
`;
export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ $collapsed })=>$collapsed ? '0' : '8px'};
  width: 100%;
  flex-shrink: 0;
  justify-content: ${({ $collapsed })=>$collapsed ? 'center' : 'flex-start'};
`;
export const BrandBlock = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 2px 8px;
  border-radius: 4px;
`;
export const BrandLogo = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 5px;
  display: block;
`;
export const BrandTitle = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-family-heading, inherit);
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  color: var(--text-primary, #161616);
`;
export const CollapseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: var(--button-secondary, #f4f4f4);
  color: var(--icon-primary, #1d1d1f);
  cursor: pointer;

  &:hover {
    background: var(--scarlet-gray-40, #f2f2f2);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
/** Collapsed header: logo only; expand control appears on hover in the same slot. */ export const CollapsedBrandHitArea = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 4px;

  ${BrandLogo} {
    transition: opacity 0.12s ease;
  }

  ${CollapseButton} {
    position: absolute;
    inset: 4px;
    width: 24px;
    height: 24px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.12s ease;
  }

  &:hover ${BrandLogo},
  &:focus-within ${BrandLogo} {
    opacity: 0;
  }

  &:hover ${CollapseButton},
  &:focus-within ${CollapseButton} {
    opacity: 1;
    pointer-events: auto;
  }
`;
export const NavSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ $collapsed })=>$collapsed ? '8px' : '0'};
  padding: ${({ $collapsed })=>$collapsed ? '0' : '8px 0'};
  flex-shrink: 0;

  &:first-of-type {
    padding-top: ${({ $collapsed })=>$collapsed ? '8px' : '16px'};
  }
`;
export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  padding: 2px 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.16px;
  color: var(--text-secondary, #525252);
  white-space: nowrap;
`;
export const NavRow = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 32px;
  padding: 2px 8px;
  border: none;
  border-radius: 4px;
  background: ${({ $active })=>$active ? 'var(--scarlet-gray-40, #f2f2f2)' : 'transparent'};
  color: var(--text-primary, #161616);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: ${({ $active })=>$active ? 'var(--scarlet-gray-40, #f2f2f2)' : 'var(--scarlet-gray-20, #f7f7f7)'};
  }
`;
export const NavIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: var(--icon-primary, #1d1d1f);

  svg {
    width: 16px;
    height: 16px;
    font-size: 16px;
  }
`;
export const AgentIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  object-fit: cover;
  display: block;
`;
export const NavLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
`;
export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: var(--red-30, #ffb3b8);
  color: var(--red-tag-color, #a2191f);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
`;
export const ChatsEmpty = styled.div`
  padding: 4px 8px;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-secondary, #525252);
`;
export const ShowMoreButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: var(--text-secondary, #525252);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: var(--scarlet-gray-20, #f7f7f7);
  }
`;
export const FooterStack = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${({ $collapsed })=>$collapsed ? '8px' : '8px'};
  width: 100%;
  margin-top: auto;
  padding-top: 8px;
  align-items: ${({ $collapsed })=>$collapsed ? 'center' : 'stretch'};
`;
export const UpdateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: ${({ $collapsed })=>$collapsed ? 'center' : 'space-between'};
  gap: 8px;
  width: ${({ $collapsed })=>$collapsed ? '32px' : '100%'};
  min-height: ${({ $collapsed })=>$collapsed ? '32px' : '48px'};
  padding: ${({ $collapsed })=>$collapsed ? '0' : '8px 10px'};
  border: 1px solid var(--scarlet-gray-60, #ededed);
  border-radius: ${({ $collapsed })=>$collapsed ? '50%' : '8px'};
  background: var(--white-100, #ffffff);
  color: var(--text-primary, #161616);
  cursor: pointer;
  text-align: left;

  &:hover:not(:disabled) {
    background: var(--scarlet-gray-20, #f7f7f7);
  }

  &:disabled {
    cursor: progress;
    opacity: 0.7;
  }
`;
export const UpdateCopy = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;
export const UpdateTitle = styled.span`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  color: var(--text-primary, #161616);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const UpdateSubtitle = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: var(--text-secondary, #525252);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const UpdateIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $collapsed })=>$collapsed ? '32px' : '24px'};
  height: ${({ $collapsed })=>$collapsed ? '32px' : '24px'};
  color: var(--icon-primary, #1d1d1f);

  svg {
    width: 16px;
    height: 16px;
    font-size: 16px;
  }
`;
export const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: ${({ $collapsed })=>$collapsed ? 'center' : 'flex-start'};
  gap: 8px;
  width: ${({ $collapsed })=>$collapsed ? '32px' : '100%'};
  min-height: 40px;
  padding: ${({ $collapsed })=>$collapsed ? '0' : '4px 8px'};
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary, #161616);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: var(--scarlet-gray-20, #f7f7f7);
  }
`;
export const ProfileAvatarWrap = styled.span`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
`;
export const PresenceDot = styled.span`
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--green-50, #24a148);
  border: 1.5px solid var(--scarlet-gray-10, #fafafa);
  box-sizing: border-box;
`;
export const ProfileMeta = styled.span`
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  flex: 1;
`;
export const ProfileName = styled.span`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  color: var(--text-primary, #161616);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const ProfileSubtitle = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: var(--text-secondary, #525252);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const PROFILE_POPOVER_OVERLAY_CLASS = 'nitro-claw-desktop-sidebar-profile-popover';
export const ProfilePopoverOverlayGlobalStyle = createGlobalStyle`
  .${PROFILE_POPOVER_OVERLAY_CLASS}.ant-popover .ant-popover-inner-content {
    padding: 0;
  }
`;
export const ProfileMenuPanel = styled.div`
  min-width: 140px;
  padding: 4px;
`;
export const ProfileLogoutLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: var(--red-60, #da1e28);
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background: var(--red-10, #fff1f1);
    color: var(--red-60, #da1e28);
  }

  svg {
    width: 14px;
    height: 14px;
    font-size: 14px;
    color: inherit;
  }
`;
